import {
  formatAmount,
  formatOddsPercent,
  formatPhoneEmail,
  formatPrice,
  validateOrderTimeRange,
} from '../futures/futuresOrderConstants';
import { inputDateTimeToQueryApi, toInputDateTime } from '../futures/futuresRoundConstants';

export const TIMED_ORDER_STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'START', label: '已下單' },
  { value: 'PROCESS', label: '進行中' },
  { value: 'END', label: '已結算' },
  { value: 'FAIL', label: '失敗' },
];

export const TIMED_ORDER_STATUS_LABELS = {
  START: '已下單',
  PROCESS: '進行中',
  END: '已結算',
  FAIL: '失敗',
};

export const TIMED_ORDER_TREND_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'UP', label: '買漲' },
  { value: 'DOWN', label: '買跌' },
];

export const TIMED_ORDER_TREND_LABELS = {
  UP: '買漲',
  DOWN: '買跌',
};

export const TIMED_PROFIT_LOSS_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'PENDING', label: '未結算' },
  { value: 'WIN', label: '盈利' },
  { value: 'LOSS', label: '虧損' },
  { value: 'FLAT', label: '持平' },
  { value: 'FAIL', label: '失敗' },
];

export const TIMED_PROFIT_LOSS_LABELS = {
  PENDING: '未結算',
  WIN: '盈利',
  LOSS: '虧損',
  FLAT: '持平',
  FAIL: '失敗',
};

export const MEMBER_ROLE_OPTIONS = [
  { value: '', label: '全部' },
  { value: '1', label: '正常帳號' },
  { value: '2', label: '試玩帳號' },
];

export const MEMBER_ROLE_LABELS = {
  1: '正常帳號',
  2: '試玩帳號',
  3: '測試帳號',
};

export function defaultTimedOrderTimeRange() {
  const now = new Date();
  const to = new Date(now);
  to.setHours(23, 59, 0, 0);

  const from = new Date(now);
  from.setDate(from.getDate() - 16);
  from.setHours(0, 0, 0, 0);

  return {
    orderTimeFromInput: toInputDateTime(from),
    orderTimeToInput: toInputDateTime(to),
  };
}

export function validateTimedOrderTimeRange(fromInput, toInput) {
  return validateOrderTimeRange(fromInput, toInput);
}

export function buildTimedOrderPageParams(pageNo, filters) {
  const params = { pageNo, pageSize: 15 };

  if (filters.status) {
    params.status = filters.status;
  }
  if (filters.orderTrend) {
    params.orderTrend = filters.orderTrend;
  }
  if (filters.roleId) {
    params.roleId = Number(filters.roleId);
  }
  if (filters.profitLossStatus) {
    params.profitLossStatus = filters.profitLossStatus;
  }

  const orderSerialId = filters.orderSerialId?.trim();
  if (orderSerialId) {
    params.orderSerialId = orderSerialId;
  }

  const memberIdsCsv = filters.memberIdsCsv?.trim();
  if (memberIdsCsv) {
    params.memberIdsCsv = memberIdsCsv;
  }

  const inviterId = filters.inviterId?.trim();
  if (inviterId) {
    params.inviterId = Number(inviterId);
  }

  const phoneEmail = filters.phoneEmail?.trim();
  if (phoneEmail) {
    params.phoneEmail = phoneEmail;
  }

  const orderTimeFrom = inputDateTimeToQueryApi(filters.orderTimeFromInput);
  const orderTimeTo = inputDateTimeToQueryApi(filters.orderTimeToInput);
  if (orderTimeFrom) {
    params.orderTimeFrom = orderTimeFrom;
  }
  if (orderTimeTo) {
    params.orderTimeTo = orderTimeTo;
  }

  return params;
}

export { formatAmount, formatOddsPercent, formatPhoneEmail, formatPrice };
